import type { ComponentType, SVGProps } from "react";
import FlatHeartIcon from "./assets/flat/heart.svg?react";
import AcornIcon from "./assets/line/acorn.svg?react";
import AddIcon from "./assets/line/add.svg?react";
import ArrowLeftIcon from "./assets/line/arrow-left.svg?react";
import ArrowRightIcon from "./assets/line/arrow-right.svg?react";
import BagIcon from "./assets/line/bag.svg?react";
import BellIcon from "./assets/line/bell.svg?react";
import BoldIcon from "./assets/line/bold.svg?react";
import BookOpenIcon from "./assets/line/book-open.svg?react";
import CactusIcon from "./assets/line/cactus.svg?react";
import CameraIcon from "./assets/line/camera.svg?react";
import CheckIcon from "./assets/line/check.svg?react";
import CheckSimpleIcon from "./assets/line/check-simple.svg?react";
import ClipboardListCheckIcon from "./assets/line/clipboard-list-check.svg?react";
import CollapseIcon from "./assets/line/collapse.svg?react";
import CompassIcon from "./assets/line/compass.svg?react";
import CubesIcon from "./assets/line/cubes.svg?react";
import DateIcon from "./assets/line/date.svg?react";
import EarthIcon from "./assets/line/earth.svg?react";
import EditIcon from "./assets/line/edit.svg?react";
import ExitIcon from "./assets/line/exit.svg?react";
import ExpandIcon from "./assets/line/expand.svg?react";
import FamilyIcon from "./assets/line/family.svg?react";
import FeaturedIcon from "./assets/line/featured.svg?react";
import FilterIcon from "./assets/line/filter.svg?react";
import GlobeIcon from "./assets/line/globe.svg?react";
import GlobeStandIcon from "./assets/line/globe-stand.svg?react";
import Heart1Icon from "./assets/line/heart-1.svg?react";
import Heart2Icon from "./assets/line/heart-2.svg?react";
import ImageIcon from "./assets/line/image.svg?react";
import InfoIcon from "./assets/line/info.svg?react";
import InfoCircleIcon from "./assets/line/info-circle.svg?react";
import InvalidIcon from "./assets/line/invalid.svg?react";
import ItalicIcon from "./assets/line/italic.svg?react";
import LeftIcon from "./assets/line/left.svg?react";
import ListBulletIcon from "./assets/line/list-bullet.svg?react";
import ListNumberedIcon from "./assets/line/list-numbered.svg?react";
import LocationIcon from "./assets/line/location.svg?react";
import MapIcon from "./assets/line/map.svg?react";
import MaximizeIcon from "./assets/line/maximize.svg?react";
import MenuIcon from "./assets/line/menu.svg?react";
import MessageIcon from "./assets/line/message.svg?react";
import MinusIcon from "./assets/line/minus.svg?react";
import MoreIcon from "./assets/line/more.svg?react";
import OliveBranchIcon from "./assets/line/olive-branch.svg?react";
import PalmTreeIcon from "./assets/line/palm-tree.svg?react";
import PaperPlaneIcon from "./assets/line/paper-plane.svg?react";
import PeopleIcon from "./assets/line/people.svg?react";
import PersonPrayingIcon from "./assets/line/person-praying.svg?react";
import PlusIcon from "./assets/line/plus.svg?react";
import QuestionIcon from "./assets/line/question.svg?react";
import RainbowIcon from "./assets/line/rainbow.svg?react";
import RightIcon from "./assets/line/right.svg?react";
import RocketIcon from "./assets/line/rocket.svg?react";
import SearchIcon from "./assets/line/search.svg?react";
import SettingsIcon from "./assets/line/settings.svg?react";
import ShareIcon from "./assets/line/share.svg?react";
import ShopIcon from "./assets/line/shop.svg?react";
import SnowflakeIcon from "./assets/line/snowflake.svg?react";
import StoreIcon from "./assets/line/store.svg?react";
import StrikethroughIcon from "./assets/line/strikethrough.svg?react";
import SwapIcon from "./assets/line/swap.svg?react";
import TrashIcon from "./assets/line/trash.svg?react";
import TreeIcon from "./assets/line/tree.svg?react";
import UnderlineIcon from "./assets/line/underline.svg?react";
import UploadIcon from "./assets/line/upload.svg?react";
import UserIcon from "./assets/line/user.svg?react";
import UserCheckIcon from "./assets/line/user-check.svg?react";
import UserXIcon from "./assets/line/user-x.svg?react";
import StickerBackpackIcon from "./assets/sticker/backpack.svg?react";
import StickerBellIcon from "./assets/sticker/bell.svg?react";
import StickerCommunityIcon from "./assets/sticker/community.svg?react";
import StickerCompassIcon from "./assets/sticker/compass.svg?react";
import StickerConfettiIcon from "./assets/sticker/confetti.svg?react";
import StickerCrownIcon from "./assets/sticker/crown.svg?react";
import StickerDateIcon from "./assets/sticker/date.svg?react";
import StickerDateAprIcon from "./assets/sticker/date-apr.svg?react";
import StickerDateAugIcon from "./assets/sticker/date-aug.svg?react";
import StickerDateDecIcon from "./assets/sticker/date-dec.svg?react";
import StickerDateFebIcon from "./assets/sticker/date-feb.svg?react";
import StickerDateJanIcon from "./assets/sticker/date-jan.svg?react";
import StickerDateJulIcon from "./assets/sticker/date-jul.svg?react";
import StickerDateJunIcon from "./assets/sticker/date-jun.svg?react";
import StickerDateMarIcon from "./assets/sticker/date-mar.svg?react";
import StickerDateMayIcon from "./assets/sticker/date-may.svg?react";
import StickerDateNovIcon from "./assets/sticker/date-nov.svg?react";
import StickerDateOctIcon from "./assets/sticker/date-oct.svg?react";
import StickerDateSepIcon from "./assets/sticker/date-sep.svg?react";
import StickerDuration1Icon from "./assets/sticker/duration-1.svg?react";
import StickerDuration2Icon from "./assets/sticker/duration-2.svg?react";
import StickerDuration3Icon from "./assets/sticker/duration-3.svg?react";
import StickerDuration4Icon from "./assets/sticker/duration-4.svg?react";
import StickerGlobeStandIcon from "./assets/sticker/globe-stand.svg?react";
import StickerHeartIcon from "./assets/sticker/heart.svg?react";
import StickerHeartInactiveIcon from "./assets/sticker/heart-inactive.svg?react";
import StickerLightbulbIcon from "./assets/sticker/lightbulb.svg?react";
import StickerLocationIcon from "./assets/sticker/location.svg?react";
import StickerMailIcon from "./assets/sticker/mail.svg?react";
import StickerMapIcon from "./assets/sticker/map.svg?react";
import StickerMembersIcon from "./assets/sticker/members.svg?react";
import StickerMenuIcon from "./assets/sticker/menu.svg?react";
import StickerMessageIcon from "./assets/sticker/message.svg?react";
import StickerProfileIcon from "./assets/sticker/profile.svg?react";
import StickerReviewIcon from "./assets/sticker/review.svg?react";
import StickerSearchIcon from "./assets/sticker/search.svg?react";
import StickerShareIcon from "./assets/sticker/share.svg?react";
import StickerShopIcon from "./assets/sticker/shop.svg?react";
import StickerStarIcon from "./assets/sticker/star.svg?react";
import StickerStoreIcon from "./assets/sticker/store.svg?react";
import StickerTreeIcon from "./assets/sticker/tree.svg?react";
import StickerUserIcon from "./assets/sticker/user.svg?react";
import StickerUsernameIcon from "./assets/sticker/username.svg?react";

export {
  AcornIcon,
  AddIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  BagIcon,
  BellIcon,
  BoldIcon,
  BookOpenIcon,
  CactusIcon,
  CameraIcon,
  CheckIcon,
  CheckSimpleIcon,
  CollapseIcon,
  DateIcon,
  EditIcon,
  ExitIcon,
  ExpandIcon,
  FamilyIcon,
  FeaturedIcon,
  FilterIcon,
  FlatHeartIcon,
  GlobeIcon,
  Heart1Icon,
  Heart2Icon,
  ImageIcon,
  InfoCircleIcon,
  InfoIcon,
  InvalidIcon,
  ItalicIcon,
  LeftIcon,
  ListBulletIcon,
  ListNumberedIcon,
  LocationIcon,
  MapIcon,
  MaximizeIcon,
  MenuIcon,
  MessageIcon,
  MinusIcon,
  MoreIcon,
  OliveBranchIcon,
  PalmTreeIcon,
  PaperPlaneIcon,
  PeopleIcon,
  PlusIcon,
  QuestionIcon,
  RightIcon,
  RocketIcon,
  SearchIcon,
  SettingsIcon,
  ShareIcon,
  ShopIcon,
  SnowflakeIcon,
  StickerBackpackIcon,
  StickerBellIcon,
  StickerCommunityIcon,
  StickerCompassIcon,
  StickerConfettiIcon,
  StickerCrownIcon,
  StickerDateIcon,
  StickerGlobeStandIcon,
  StickerHeartIcon,
  StickerHeartInactiveIcon,
  StickerLightbulbIcon,
  StickerLocationIcon,
  StickerMailIcon,
  StickerMapIcon,
  StickerMembersIcon,
  StickerMenuIcon,
  StickerMessageIcon,
  StickerProfileIcon,
  StickerReviewIcon,
  StickerSearchIcon,
  StickerShareIcon,
  StickerShopIcon,
  StickerStarIcon,
  StickerStoreIcon,
  StickerTreeIcon,
  StickerUserIcon,
  StickerUsernameIcon,
  StoreIcon,
  StrikethroughIcon,
  SwapIcon,
  TrashIcon,
  UnderlineIcon,
  UploadIcon,
  UserCheckIcon,
  UserIcon,
  UserXIcon,
};

export type SvgComponent = ComponentType<SVGProps<SVGSVGElement>>;

export const lineIconMap = {
  acorn: AcornIcon,
  clipboardListCheck: ClipboardListCheckIcon,
  compass: CompassIcon,
  cubes: CubesIcon,
  globeStand: GlobeStandIcon,
  info: InfoIcon,
  infoCircle: InfoCircleIcon,
  personPraying: PersonPrayingIcon,
  rainbow: RainbowIcon,
  tree: TreeIcon,
  add: AddIcon,
  bold: BoldIcon,
  italic: ItalicIcon,
  underline: UnderlineIcon,
  strikethrough: StrikethroughIcon,
  listBullet: ListBulletIcon,
  listNumbered: ListNumberedIcon,
  bookOpen: BookOpenIcon,
  cactus: CactusIcon,
  camera: CameraIcon,
  arrowLeft: ArrowLeftIcon,
  arrowRight: ArrowRightIcon,
  bag: BagIcon,
  bell: BellIcon,
  check: CheckIcon,
  checkSimple: CheckSimpleIcon,
  collapse: CollapseIcon,
  date: DateIcon,
  earth: EarthIcon,
  edit: EditIcon,
  exit: ExitIcon,
  expand: ExpandIcon,
  family: FamilyIcon,
  featured: FeaturedIcon,
  filter: FilterIcon,
  globe: GlobeIcon,
  heart1: Heart1Icon,
  heart2: Heart2Icon,
  image: ImageIcon,
  invalid: InvalidIcon,
  left: LeftIcon,
  location: LocationIcon,
  map: MapIcon,
  maximize: MaximizeIcon,
  menu: MenuIcon,
  message: MessageIcon,
  minus: MinusIcon,
  more: MoreIcon,
  oliveBranch: OliveBranchIcon,
  palmTree: PalmTreeIcon,
  paperPlane: PaperPlaneIcon,
  people: PeopleIcon,
  plus: PlusIcon,
  question: QuestionIcon,
  right: RightIcon,
  rocket: RocketIcon,
  search: SearchIcon,
  settings: SettingsIcon,
  share: ShareIcon,
  shop: ShopIcon,
  snowflake: SnowflakeIcon,
  store: StoreIcon,
  swap: SwapIcon,
  trash: TrashIcon,
  upload: UploadIcon,
  user: UserIcon,
  userCheck: UserCheckIcon,
  userX: UserXIcon,
} as const satisfies Record<string, SvgComponent>;

export const stickerIconMap = {
  backpack: StickerBackpackIcon,
  bell: StickerBellIcon,
  community: StickerCommunityIcon,
  compass: StickerCompassIcon,
  confetti: StickerConfettiIcon,
  crown: StickerCrownIcon,
  date: StickerDateIcon,
  dateJan: StickerDateJanIcon,
  dateFeb: StickerDateFebIcon,
  dateMar: StickerDateMarIcon,
  dateApr: StickerDateAprIcon,
  dateMay: StickerDateMayIcon,
  dateJun: StickerDateJunIcon,
  dateJul: StickerDateJulIcon,
  dateAug: StickerDateAugIcon,
  dateSep: StickerDateSepIcon,
  dateOct: StickerDateOctIcon,
  dateNov: StickerDateNovIcon,
  dateDec: StickerDateDecIcon,
  duration1: StickerDuration1Icon,
  duration2: StickerDuration2Icon,
  duration3: StickerDuration3Icon,
  duration4: StickerDuration4Icon,
  globeStand: StickerGlobeStandIcon,
  heart: StickerHeartIcon,
  heart1: StickerHeartIcon,
  heartInactive: StickerHeartInactiveIcon,
  lightbulb: StickerLightbulbIcon,
  location: StickerLocationIcon,
  mail: StickerMailIcon,
  map: StickerMapIcon,
  members: StickerMembersIcon,
  menu: StickerMenuIcon,
  message: StickerMessageIcon,
  profile: StickerProfileIcon,
  review: StickerReviewIcon,
  search: StickerSearchIcon,
  share: StickerShareIcon,
  shop: StickerShopIcon,
  star: StickerStarIcon,
  store: StickerStoreIcon,
  tree: StickerTreeIcon,
  user: StickerUserIcon,
  username: StickerUsernameIcon,
} as const satisfies Record<string, SvgComponent>;

export const flatIconMap = {
  heart: FlatHeartIcon,
} as const satisfies Record<string, SvgComponent>;

export type LineIconName = keyof typeof lineIconMap;
export type StickerIconName = keyof typeof stickerIconMap;
export type FlatIconName = keyof typeof flatIconMap;
export type IconName = LineIconName | StickerIconName | FlatIconName;

/** @deprecated Use `lineIconMap` instead */
export const iconMap = lineIconMap;
